import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer>
      <div className="f-view">
        <div className="f-row">
          <div className="f-col-s6-m3-l2">
            <h3 className="marginless">CS2N</h3>
            <a href="https://www.cs2n.org/u/tracks?track_id=509">
              Virtual Robot Curriculum
            </a>
            <a href="https://games.cs2n.org/">Games</a>
            <a href="https://www.cs2n.org/curriculum">Curriculum</a>
            <a href="https://www.cs2n.org/catalog">Catalog</a>
            <a
              href="https://www.cmu.edu/roboticsacademy/Training/certificationsv2.html"
              target="_blank"
              rel="noreferrer"
            >
              Certifications Info
            </a>
          </div>

          <div className="f-col-s6-m3-l2">
            <h3 className="marginless">For Teachers</h3>
            <a href="https://www.cs2n.org/u/tracks?track_id=515">
              Getting Started
            </a>
            <a href="https://www.cs2n.org/premium">CS2N Premium</a>
            <a href="https://www.cs2n.org/google_classrooms">
              Google Classrooms
            </a>
            <a
              href="https://www.cmu.edu/roboticsacademy/Research/index.html"
              target="_blank"
              rel="noreferrer"
            >
              Research
            </a>
            <a
              href="https://www.cmu.edu/roboticsacademy/Training/"
              target="_blank"
              rel="noreferrer"
            >
              Teacher Training
            </a>
          </div>

          <hr className="screen-s-down" />

          <div className="f-col-s6-m3-l2">
            <h3 className="marginless">About Us</h3>
            <a
              href="https://www.cs2n.org/support/contact"
              target="_blank"
              rel="noreferrer"
            >
              Contact
            </a>
            <a href="https://www.cs2n.org/about">History</a>
            <a
              href="https://www.cmu.edu/roboticsacademy/about/team.html"
              target="_blank"
              rel="noreferrer"
            >
              Team
            </a>
            <a href="https://www.cs2n.org/policies">Store Policies</a>
            <a href="https://www.cs2n.org/tos">Terms</a>
            <a href="https://www.cs2n.org/privacy">Privacy</a>
            <a href="https://www.cs2n.org/compliance">Compliance</a>
          </div>

          <div className="f-col-s6-m3-l2">
            <h3 className="marginless">Follow Us</h3>
            <a
              href="https://www.cmu.edu/roboticsacademy/news/index.html"
              target="_blank"
              rel="noreferrer"
            >
              News
            </a>
            <a
              href="https://www.facebook.com/CMURoboticsAcademy/?fref=ts"
              target="_blank"
              rel="noreferrer"
            >
              Facebook
            </a>
            <a
              href="https://twitter.com/CMUCMRA"
              target="_blank"
              rel="noreferrer"
            >
              Twitter
            </a>
            <a
              href="https://www.youtube.com/user/RoboticsAcademy"
              target="_blank"
              rel="noreferrer"
            >
              Youtube
            </a>
          </div>

          <hr className="screen-s-down" />

          <div className="f-col-s12-l4">
            <h3 className="marginless">Donate to support the mission!</h3>
            <p className="margin-top-0">
              The Carnegie Mellon Robotics Academy has been providing free
              curricula and resources for Robotics Education for over 20 years.
              We hope that you find the courses, games, teaching tools, and
              other resources useful! We appreciate any help that you can
              provide to help sustain our mission!
            </p>
            <div className="flex f-justify-center">
              <a
                href="https://givenow.cmu.edu/scs/?a=8606842&designation=carnegiemellonroboticsacademy"
                className="btn radius expand"
                target="_blank"
                rel="noreferrer"
              >
                <i></i>
                Donate
              </a>
            </div>
          </div>

          <div className="f-col-s12">
            <h3 className="text-center">
              <i className="bx bxs-copyright"></i>
              {`© ${year} Carnegie Mellon University. All rights reserved.`}
            </h3>
          </div>
        </div>
      </div>
    </footer>
  );
}
